export default __webpack_public_path__ + "bg3115acc.png";